import { render, staticRenderFns } from "./BaseTableComponent.vue?vue&type=template&id=bc32578a"
import script from "./BaseTableComponent.vue?vue&type=script&lang=js"
export * from "./BaseTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports